<template>
  <!-- <font-awesome-icon
    v-tooltip="'לעמוד הבא'"
    icon="arrow-left"
    class="arrows arrow-right"
    @click="nextPage"
    :class="{ disabled: !isActive }"
  />-->
  <div class="mef-font mef-font-default arrows arrow-left flex full-center">
    <div class="flex full-center">
      <span
        v-tooltip="'לעמוד הבא'"
        class="mef-font mef-font-default"
        @click="nextPage"
        :class="{ disabled: !isActive }"
        style="line-height: 24px;
    width: 26px;"
      >
        <HoverGray
          h="25"
          w="25"
          t="0"
          l="-1"
          bgcolor="rgb(0,0,0,0.1)"
          fgcolor="white"
          >j</HoverGray
        >
      </span>
    </div>
  </div>
  <!-- <span
    v-tooltip="'לעמוד הבא'"
    class="mef-font mef-font-default arrows arrow-left"
    @click="nextPage"
    
  >j</span>-->
</template>

<script>
import { ShasBooks } from "@/services/mefo/shasService";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("mefShas", [
      "getSelectedPageNumber",
      "getSelectedBookNumber",
    ]),
    isActive() {
      let page = this.getSelectedPageNumber;
      let bookid = this.getSelectedBookNumber;
      if (bookid == null) return false;
      page = Number(page) + 1;
      let bookData = ShasBooks[bookid];
      if (page >= bookData.count + bookData.firstPage) {
        return false;
      }
      return true;
    },
  },
  methods: {
    nextPage() {
      let page = this.getSelectedPageNumber;
      // let tab = this.$store.getters.getCurrentTab.tabId;
      page = Number(page) + 1;
      // this.$router.push({
      //   name: "n-main-page",
      //   params: { bookid: this.getSelectedBookNumber, page, tab },
      // });
    },
    checkKey(e) {
      if (e.key == "ArrowLeft" && e.ctrlKey) this.nextPage();
    },
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.checkKey, false);
  },
  created() {
    document.addEventListener("keyup", this.checkKey, false);
  },
};
</script>

<style>
.disabled {
  color: white;
  opacity: 0.3;
}
.arrow-left {
  margin-right: 5px;
  width: 24px;
  margin-left: 5px;
  height: 31px;
  line-height: 31px;
  color: white;
  text-align: left;
}
</style>
